import React from 'react';
import { motion } from 'framer-motion';
import { Zap, ShieldCheck, Lock, CreditCard, Clock, Check, AlertTriangle } from 'lucide-react';
import { Countdown } from './Countdown';
export function FinalCTA() {
  return <section className="py-14 bg-petroleum relative overflow-hidden border-t border-electric/20" data-id="element-243">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[800px] bg-radial-glow pointer-events-none opacity-40" data-id="element-244"></div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-245">
        {/* Framed Countdown Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="relative max-w-3xl mx-auto mb-10" data-id="element-246">
          <div className="absolute -inset-1 bg-danger rounded-3xl blur-xl opacity-20" data-id="element-247"></div>
          <div className="relative bg-gradient-to-br from-graphite via-petroleum to-graphite border-2 border-danger rounded-3xl p-8 md:p-10 text-center overflow-hidden shadow-2xl shadow-danger/20" data-id="element-248">
            <div className="absolute inset-0 opacity-[0.08] pointer-events-none" style={{
            backgroundImage: 'linear-gradient(rgba(255,90,90,0.6) 1px, transparent 1px), linear-gradient(90deg, rgba(255,90,90,0.6) 1px, transparent 1px)',
            backgroundSize: '24px 24px'
          }} data-id="element-249"></div>
            <div className="absolute top-0 left-0 w-14 h-14 border-t-4 border-l-4 border-danger rounded-tl-3xl pointer-events-none" data-id="element-250"></div>
            <div className="absolute top-0 right-0 w-14 h-14 border-t-4 border-r-4 border-danger rounded-tr-3xl pointer-events-none" data-id="element-251"></div>
            <div className="absolute bottom-0 left-0 w-14 h-14 border-b-4 border-l-4 border-danger rounded-bl-3xl pointer-events-none" data-id="element-252"></div>
            <div className="absolute bottom-0 right-0 w-14 h-14 border-b-4 border-r-4 border-danger rounded-br-3xl pointer-events-none" data-id="element-253"></div>

            <div className="relative z-10" data-id="element-254">
              <div className="inline-flex items-center gap-2 bg-danger text-white px-4 py-1.5 rounded-full text-xs font-extrabold uppercase tracking-wider mb-5 shadow-lg shadow-danger/40" data-id="element-255">
                <AlertTriangle className="w-3.5 h-3.5" strokeWidth={2.5} data-id="element-256" />
                Última oportunidad
              </div>
              <h2 className="text-2xl md:text-4xl font-extrabold leading-tight mb-5" data-id="element-257">
                <span className="text-white" data-id="element-258">El precio </span>
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-danger via-danger to-danger drop-shadow-[0_0_12px_rgba(255,90,90,0.4)]" data-id="element-259">
                  cierra en:
                </span>
              </h2>
              <Countdown data-id="element-260" />
              <div className="mt-5 mx-auto h-px w-32 bg-gradient-to-r from-transparent via-danger to-transparent opacity-70" data-id="element-261"></div>
            </div>
          </div>
        </motion.div>

        <div className="max-w-4xl mx-auto grid md:grid-cols-2 gap-6 mb-8" data-id="element-262">
          {/* Basic Plan Mini */}
          <div className="bg-graphite border border-white/10 rounded-2xl p-6 text-center hover:border-electric/30 transition-all" data-id="element-263">
            <h3 className="text-xl font-bold mb-2" data-id="element-264">📘 MEGAPACK FREELANCER</h3>
            <p className="text-sm text-textsecondary mb-4" data-id="element-265">
              6 Tomos + 6 Bonos · De 0 a Ingresos en USD
            </p>
            <div className="mb-6" data-id="element-266">
              <span className="text-textsecondary line-through text-sm mr-2" data-id="element-267">
                $36.990
              </span>
              <span className="text-3xl font-extrabold text-white" data-id="element-268">
                $19.990{' '}
                <span className="text-lg text-textsecondary font-medium" data-id="element-269">
                  ARS
                </span>
              </span>
            </div>
            <a href="https://www.bibliotecasdigitales.store/checkouts/cn/hWNCwIQGq6UvqQYFgB9Cf2Bu/es-ar?_r=AQAB9hFFq0h48SmEqJv7GZ-kew2cW-GaWxTz_UyxzELZiuc&cart_link_id=d1hIZBeQ&preview_theme_id=154708803747" target="_blank" rel="noopener noreferrer" className="group relative w-full bg-gradient-to-r from-petroleum to-petroleum/80 hover:from-electric/20 hover:to-electric/10 border border-electric/50 hover:border-electric text-white font-bold py-3 rounded-xl transition-all duration-300 flex items-center justify-between gap-2 pl-3 pr-2 shadow-md hover:shadow-lg hover:shadow-electric/20" data-id="element-270">
              <span className="flex-shrink-0 w-7 h-7 rounded-lg bg-electric/15 border border-electric/30 flex items-center justify-center group-hover:bg-electric/25 transition-colors" data-id="element-271">
                <Zap className="w-3.5 h-3.5 text-electric fill-electric" data-id="element-272" />
              </span>
              <span className="flex-1 text-center text-sm tracking-wide" data-id="element-273">
                QUIERO MI MEGAPACK
              </span>
              <span className="flex-shrink-0 w-7 h-7 rounded-lg bg-electric/15 text-electric flex items-center justify-center group-hover:translate-x-0.5 transition-transform" data-id="element-274">
                <Check className="w-3.5 h-3.5" strokeWidth={3} data-id="element-275" />
              </span>
            </a>
          </div>

          {/* Pro Plan Mini */}
          <div className="bg-gradient-to-b from-[#1a1a1a] to-petroleum border-2 border-electric rounded-2xl p-6 text-center relative glow-electric" data-id="element-276">
            <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-gold text-graphite font-bold px-3 py-0.5 rounded-full text-xs flex items-center gap-1" data-id="element-277">
              <Zap className="w-3 h-3 fill-graphite" data-id="element-278" /> MÁS POPULAR
            </div>
            <h3 className="text-xl font-bold mb-2 text-gold" data-id="element-279">
              🚀 MEGAPACK + FREELANCER PRO
            </h3>
            <p className="text-sm text-textsecondary mb-4" data-id="element-280">
              6 Tomos + 6 Bonos + El Sistema para Llegar a tus Primeros USD
              1.000
            </p>
            <div className="mb-6" data-id="element-281">
              <span className="text-textsecondary line-through text-sm mr-2" data-id="element-282">
                $49.990
              </span>
              <span className="text-3xl font-extrabold text-white" data-id="element-283">
                $27.990{' '}
                <span className="text-lg text-textsecondary font-medium" data-id="element-284">
                  ARS
                </span>
              </span>
            </div>
            <a href="https://www.bibliotecasdigitales.store/checkouts/cn/hWNCwIUGafYS5nPcbhYiPJiM/es-ar?_r=AQAB5nA537G_jVoVCWWD5JPt1bF5pOkp3daLIPvDahYhSD8&cart_link_id=HRttMM5W&preview_theme_id=154708803747" target="_blank" rel="noopener noreferrer" className="group relative w-full bg-gradient-to-r from-gold via-gold to-gold hover:from-gold hover:via-gold hover:to-gold border border-gold text-graphite font-bold py-3 rounded-xl transition-all duration-300 flex items-center justify-between gap-2 pl-3 pr-2 shadow-md hover:shadow-lg hover:shadow-gold/40" data-id="element-285">
              <span className="flex-shrink-0 w-7 h-7 rounded-lg bg-graphite/15 border border-graphite/20 flex items-center justify-center" data-id="element-286">
                <Zap className="w-3.5 h-3.5 text-graphite fill-graphite" data-id="element-287" />
              </span>
              <span className="flex-1 text-center text-sm tracking-wide" data-id="element-288">
                QUIERO EL COMBO COMPLETO
              </span>
              <span className="flex-shrink-0 w-7 h-7 rounded-lg bg-graphite text-gold flex items-center justify-center group-hover:translate-x-0.5 transition-transform" data-id="element-289">
                <Check className="w-3.5 h-3.5" strokeWidth={3} data-id="element-290" />
              </span>
            </a>
          </div>
        </div>

        {/* Trust Row */}
        <div className="flex flex-wrap items-center justify-center gap-6 md:gap-12 text-sm text-textsecondary font-medium" data-id="element-291">
          <div className="flex items-center gap-2" data-id="element-292">
            <Lock className="w-5 h-5 text-electric" data-id="element-293" /> Pago 100% seguro
          </div>
          <div className="flex items-center gap-2" data-id="element-294">
            <Clock className="w-5 h-5 text-electric" data-id="element-295" /> Acceso en 5 minutos
          </div>
          <div className="flex items-center gap-2" data-id="element-296">
            <ShieldCheck className="w-5 h-5 text-electric" data-id="element-297" /> Garantía 7 días
          </div>
          <div className="flex items-center gap-2" data-id="element-298">
            <CreditCard className="w-5 h-5 text-electric" data-id="element-299" /> Mercado Pago —
            Tarjeta — Transferencia
          </div>
        </div>
      </div>
    </section>;
}